import { render } from "./MenuUnderline.vue?vue&type=template&id=4e0bf657&scoped=true"
import script from "./MenuUnderline.vue?vue&type=script&lang=js"
export * from "./MenuUnderline.vue?vue&type=script&lang=js"

import "./MenuUnderline.vue?vue&type=style&index=0&id=4e0bf657&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0bf657"]])

export default __exports__